"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyMenuConfigurationLinksData = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyDrawFunction_1 = require("./SankeyDrawFunction");
const d3 = __importStar(require("d3"));
const SankeyMenuConfigurationLinksData = (data, tags_selected, set_tags_selected, selected_link, multi_selected_links, set_data, t, additional_data_element, displayed_value, set_displayed_value) => {
    const isAllLinkToPrecision = (multi_selected_links) => {
        let toPrecision = true;
        multi_selected_links.current.map(d => {
            toPrecision = (d.to_precision) ? toPrecision : false;
        });
        return toPrecision;
    };
    return react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "flux_data", title: t('Flux.data.données') },
        react_1.default.createElement(react_bootstrap_1.Form, null,
            //Définition des valeurs selon les paramètre dataTags
            Object.entries(data.dataTags).map(([dataTagKey, dataTag]) => {
                if (Object.keys(dataTag.tags).length != 0) {
                    return (react_1.default.createElement(react_bootstrap_1.Row, { key: dataTagKey },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                            react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                                dataTag.group_name,
                                " :")),
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                            react_1.default.createElement(react_bootstrap_1.Form.Select, { name: dataTagKey, value: tags_selected[dataTagKey], onChange: (evt) => {
                                    //Modifie les paramètres selectionnés
                                    const { name, value } = evt.target;
                                    let tmp = {};
                                    set_tags_selected(prevState => {
                                        tmp = (Object.assign(Object.assign({}, prevState), { [name]: value }));
                                        return (Object.assign(Object.assign({}, prevState), { [name]: value }));
                                    });
                                    set_displayed_value(SankeyDrawFunction_1.value_selected_parameter(data, multi_selected_links, tmp).value);
                                } }, Object.entries(dataTag.tags).map(([tag_key, tag]) => {
                                return (react_1.default.createElement("option", { key: tag.name, value: tag_key }, tag.name));
                            })))));
                }
            }),
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Flux.data.vpp'))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 12 },
                            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.data.tooltips.1', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.data.tooltips.1' },
                                    t('Flux.data.tooltips.vpp'),
                                    " ") },
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { className: 'inputValueLink', type: 'text', value: displayed_value, onChange: evt => {
                                        set_displayed_value(evt.target.value);
                                        const formatedValue = evt.target.value.replace(',', '.');
                                        if (formatedValue != '' && isNaN(+formatedValue)) {
                                            d3.select('.inputValueLink').style('border', 'red 1px solid');
                                        }
                                        else {
                                            d3.select('.inputValueLink').style('border', '#ced4da 1px solid');
                                        }
                                    }, onBlur: evt => {
                                        const formatedValue = evt.target.value.replace(',', '.');
                                        if (formatedValue !== '' && !isNaN(+formatedValue)) {
                                            const was_empty = SankeyDrawFunction_1.value_selected_parameter(data, multi_selected_links, tags_selected).value === '';
                                            let val = Object(selected_link.current.value);
                                            multi_selected_links.current.map(d => {
                                                d.dashed = (was_empty) ? false : d.dashed;
                                                val = d.value;
                                                Object.values(tags_selected).forEach(tag => {
                                                    if (val[tag] === undefined) {
                                                        val[tag] = {};
                                                    }
                                                    val = val[tag];
                                                });
                                                val.value = +formatedValue;
                                            });
                                            const scale = d3.scaleLinear()
                                                .domain([0, data.user_scale])
                                                .range([0, 100]);
                                            if (scale(+formatedValue) > 500) {
                                                data.user_scale = +formatedValue;
                                            }
                                            set_data(Object.assign({}, data));
                                        }
                                        else if (formatedValue == '') {
                                            let val = Object(selected_link.current.value);
                                            multi_selected_links.current.map(d => {
                                                val = d.value;
                                                d.dashed = true;
                                                Object.values(tags_selected).forEach(tag => {
                                                    if (val[tag] === undefined) {
                                                        val[tag] = {};
                                                    }
                                                    val = val[tag];
                                                });
                                                val.value = '';
                                            });
                                            set_data(Object.assign({}, data));
                                        }
                                    } })))),
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.data.tooltips.2', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.data.tooltips.2' },
                                    t('Flux.data.tooltips.toPrecision'),
                                    " ") },
                                react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: isAllLinkToPrecision(multi_selected_links), onChange: evt => {
                                        Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => d.to_precision = evt.target.checked);
                                        set_data(Object.assign({}, data));
                                    } }))),
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                            react_1.default.createElement(react_bootstrap_1.Form.Label, null, t('Flux.data.toPrecision')))))),
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Flux.data.affichage'))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.data.tooltips.3', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.data.tooltips.3' },
                            t('Flux.data.tooltips.affichage'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'text', value: SankeyDrawFunction_1.value_selected_parameter(data, multi_selected_links, tags_selected).display_value, onChange: evt => {
                                let val = Object(selected_link.current.value);
                                multi_selected_links.current.map(d => {
                                    val = d.value;
                                    Object.values(tags_selected).forEach(tag => {
                                        if (val[tag] === undefined) {
                                            val[tag] = {};
                                        }
                                        val = val[tag];
                                    });
                                    val.display_value = evt.target.value;
                                });
                                set_data(Object.assign({}, data));
                            } })))),
            additional_data_element));
};
exports.SankeyMenuConfigurationLinksData = SankeyMenuConfigurationLinksData;
